import { logout, refresh, uuid, humanizeDuration, toSIUnit, formatDate } from "@/services/helpers";

import dayjs from "@/services/dayjs";
import luxon from "@/services/luxon";
import { Info } from "luxon";

export default {
  install(Vue) {

    Vue.prototype.$laravel = window.Laravel;
    Vue.prototype.$laravel.route = window.route;

    Vue.dayjs = dayjs;
    Vue.prototype.$dayjs = dayjs;

    Vue.luxon = luxon;
    Vue.prototype.$luxon = luxon;
    Vue.prototype.$luxonInfo = Info;

    Vue._ = _;
    Vue.prototype._ = _;
    Vue.prototype.$_ = _;

    Vue.prototype.$refresh = refresh;
    Vue.prototype.$logout = logout;
    Vue.prototype.$uuid = uuid;
    Vue.prototype.$humanizeDuration = humanizeDuration;
    Vue.prototype.$toSIUnit = toSIUnit;

    Vue.prototype.$formatDate = formatDate;
  }
};
